import React from "react";
import {
  Alert, FormControl, InputLabel, MenuItem, Select, Stack, ToggleButton, ToggleButtonGroup, Typography, Paper,
} from "@mui/material";

export default function Step3FetchConfig({
  dbParent,
  selectedGbifCount,
  fetchMode,
  fetchDepth,
  onChangeFetchMode,
  onChangeFetchDepth,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="h6">Step 3: 検索・マージ設定</Typography>
        <Typography>以下の設定でGBIFからデータを取得します。</Typography>
        <Alert severity="info">
          <Typography variant="body2">起点 (DB): <strong>{dbParent?.name_spell_valid}</strong></Typography>
          <Typography variant="body2">起点 (GBIF): <strong>{selectedGbifCount}</strong> 件のID</Typography>
        </Alert>
        <ToggleButtonGroup value={fetchMode} exclusive onChange={(_, v) => { if (v) onChangeFetchMode?.(v); }} size="small" aria-label="fetch mode">
          <ToggleButton value="self_only">自身のみを更新</ToggleButton>
          <ToggleButton value="descendants_only">配下のみ取得</ToggleButton>
          <ToggleButton value="self_and_descendants">自身と配下を取得</ToggleButton>
        </ToggleButtonGroup>
        {fetchMode !== 'self_only' && (
          <FormControl size="small" sx={{ maxWidth: 200 }}>
            <InputLabel>取得深度</InputLabel>
            <Select value={fetchDepth} label="取得深度" onChange={(e) => onChangeFetchDepth?.(e.target.value)}>
              {[1, 2, 3, 4, 5].map(d => <MenuItem key={d} value={d}>{d}階層</MenuItem>)}
              <MenuItem value={10}>すべて</MenuItem>
            </Select>
          </FormControl>
        )}
      </Stack>
    </Paper>
  );
}
